import { getCurrentScope } from '@rover/rsdk/src/modules/ErrorReporting/sentry/lib';

export const setSentryTag = (key: string, value?: string): void => {
  if (getCurrentScope !== undefined) {
    getCurrentScope().setTag(key, value);
  }
};
